module.exports = __webpack_public_path__ + "img/Stewardship-2021.ffd71df2.png";